<template>
  <div>
    <!--Layui Table-->
    <div class="v-record x-admin-sm">
      <div class="content">
        <div class="layui-fluid">
          <div class="layui-row layui-col-space15">
            <div class="layui-col-md12">
              <div class="layui-card">
                <div class="layui-card-body ">
                  <form class="layui-form layui-col-space5 btns">
                    <div class="layui-inline layui-show-xs-block">
                      <input type="text" name="query" placeholder="关键字查询" class="layui-input">
                    </div>
                    <div class="layui-input-inline layui-show-xs-block">
                      <select name="taskName">
                        <option value="">根据节点筛选</option>
                        <option value="已完成">已完成</option>
                        <option value="部门主管审批">部门主管审批</option>
                        <option value="财务复核">财务复核</option>
                        <option value="财务经理审批">财务经理审批</option>
                        <option value="总经办审批">总经办审批</option>
                        <option value="出纳付款">出纳付款</option>
                      </select>
                    </div>
                    <div class="v-s-w" style="display: inline-block;">
                      <input type="checkbox" id="isShowZqjs" name="isShowZqjs" class="checkbox" style="display:none;" lay-ignore>
                      <label for="isShowZqjs" class="checkbox_label btn"><span>显示周期结算</span></label>
                    </div>
                    <div class="v-s-w" style="display: inline-block;">
                      <input type="checkbox" id="isShowCqxj" name="isShowCqxj" class="checkbox" style="display:none;" lay-ignore>
                      <label for="isShowCqxj" class="checkbox_label btn"><span>显示出勤休假</span></label>
                    </div>
                    <div class="layui-inline layui-show-xs-block">
                      <button class="layui-btn" lay-submit="sreach" lay-filter="sreach">
                        <i class="layui-icon">&#xe615;</i></button>
                    </div>
                  </form>
                </div>
                <div class="layui-card-body ">
                  <div id="member_list" lay-filter="User"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <script type="text/html" id="toolbarDemo">
        <div class="layui-btn-container">
          <button class="layui-btn" lay-event="exportExcel"><i class="layui-icon layui-icon-export"></i>导出为Excel</button>
        </div>
      </script>
      <script type="text/html" id="manage">
        <a class="btn" title="预览表单" lay-event="viewTask" href="javascript:;">
          <i class="layui-icon layui-icon-form"></i>
        </a>
      </script>
    </div>
    <router-view></router-view>
    <ImgViewer ref="imgViewer"></ImgViewer>
  </div>
</template>

<script>
import LayuiTableInfo from "@/assets/models/LayuiTableInfo";
import util from "@/util";
import '@/assets/layui/css/xadmin.css'
import ImgViewer from "@/components/ImgViewer";

export default {
  data() {
    return {}
  },
  components: { ImgViewer },
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  methods: {
    openProc(procInstId) {
      this.$router.push({
        // path: '/proc/view',
        name: '查看记录',
        params: {
          id: procInstId,
          backUrlName: '审批记录'
        }
      })
    },
    openImgViewer(attachment, i) {
      this.$refs.imgViewer.init(attachment, i);
    }
  },
  mounted() {
    let self = this;
    let tableParams = LayuiTableInfo.getTableParams();
    this.$('[name=query]').val(tableParams.query);
    this.$('[name=taskName]').val(tableParams.taskName);
    this.$('[name=isShowZqjs]').get(0).checked = tableParams.isShowZqjs;
    this.$('[name=isShowCqxj]').get(0).checked = tableParams.isShowCqxj;
    util.loadJS('https://www.layuicdn.com/layui/layui.js', () => {
      let layui = window.layui;
      layui.use('table', function () {
        let table = window.table = layui.table;

        layui.form.render();
        table.render({
          id: 'User',
          title: '用户表',
          elem: '#member_list',
          autoSort: false,
          url: self.baseURL + '/sp/process/list',
          where: {
            query: tableParams.query,
            taskName: tableParams.taskName,
            isShowZqjs: tableParams.isShowZqjs,
            isShowCqxj: tableParams.isShowCqxj,
            orderBy: tableParams.orderBy,
            order: tableParams.order,
            username: self.user.name
          },
          parseData(res) {
            return {
              "code": res.code === 1 ? 0 : 1,
              "msg": res.msg,
              "count": res.data.total,
              "data": res.data.list
            };
          },
          limits: [10, 20, 50, 100, 200],
          request: { limitName: 'pageSize' },
          page: {
            limit: tableParams.pageSize === undefined ? 10 : tableParams.pageSize,
            curr: tableParams.page === undefined ? 1 : tableParams.page + 1
          },
          cols: LayuiTableInfo.cols,
          toolbar: '#toolbarDemo',
          initSort: {
            field: tableParams.orderBy || 'hp.start_time_',
            type: tableParams.order || 'desc'
          }
        });

        function reloadTable(obj) {
          if (obj) {
            LayuiTableInfo.setTableParams('orderBy', obj.field);
            LayuiTableInfo.setTableParams('order', obj.type)
          }
          let p = LayuiTableInfo.getTableParams();
          table.reload('User', {
            initSort: {
              field: p.orderBy,
              type: p.order
            },
            where: {
              query: p.query,
              taskName: p.taskName,
              isShowCqxj: p.isShowCqxj,
              isShowZqjs: p.isShowZqjs,
              username: self.user.name,
              orderBy: p.orderBy,
              order: p.order
            }
          });
          return false;
        }

        layui.form.on('submit(sreach)', function (data) {
          LayuiTableInfo.setTableParams('query', data.field.query);
          LayuiTableInfo.setTableParams('taskName', data.field.taskName);
          LayuiTableInfo.setTableParams('isShowZqjs', !!data.field.isShowZqjs);
          LayuiTableInfo.setTableParams('isShowCqxj', !!data.field.isShowCqxj);
          reloadTable();
          return false;
        });

        layui.form.on('checkbox', res => {
          let spTable = LayuiTableInfo.getSpStorage();
          // $.shoukuan = true
          spTable[res.elem.name] = res.elem.checked;
          LayuiTableInfo.saveSpStorage(spTable);
        })

        table.on('sort(User)', reloadTable);
        table.on('tool(User)', function (obj) {
          switch (obj.event) {
            case 'viewTask':
              self.openProc(obj.data.id)
          }
        });
        table.on('toolbar(User)', function (obj) {
          if (obj.event === 'batchDel') {
            const checkStatus = table.checkStatus(obj.config.id);
            if (!checkStatus.data.length) return;
            let ids = [];
            checkStatus.data.forEach(function (item) {
              ids.push(item.procInstId);
            });
            self.$layer.confirm('确认删除' + ids.length + '条数据吗？', () => {
              util.loadBegin();
              self.$post('/sp/process/del', ids, () => {
                checkStatus.isAll ? location.reload() : table.reload('User');
              });
            })
          } else if (obj.event === 'exportExcel') {
            util.loadBegin();
            let params = LayuiTableInfo.getTableParams();
            self.$get('/sp/process/list', {
              page: 1,
              pageSize: 99999,
              isShowCqxj: params.isShowCqxj,
              isShowZqjs: params.isShowZqjs,
              username: self.user.name,
              query: params.query,
              taskName: params.taskName,
              orderBy: params.orderBy,
              order: params.order
            }, res => {
              util.loadClose();
              let tableField = LayuiTableInfo.getTableField();
              let tableValueByData = LayuiTableInfo.getTableValueByData(res.list);
              table.exportFile(tableField, tableValueByData, 'xls');
            });
          }
        });

        window.openFujian = (tableIndex, imgIndex) => {
          self.$('.layui-icon.layui-table-tips-c.layui-icon-close').trigger('click')
          let attachment = table.cache.User[tableIndex].data.fujians;
          attachment = Array.from(attachment, item => self.img(item));
          self.openImgViewer(attachment, imgIndex);
        }
      })
    })
  },
}
</script>

<style>
/*.v-record.app-content {*/
/*  background: #fff;*/
/*}*/

.v-record .content {
  display: block;
  max-width: 100%;
}

.v-record .icon {
  padding: 0;
}

.v-record .layui-btn,
.v-record .layui-btn:not(.layui-btn-danger),
.v-record .layui-laypage .layui-laypage-curr .layui-laypage-em {
  background-color: rgb(80, 95, 121);
}

.v-record .layui-form-select dl dd.layui-this {
  background-color: rgb(116, 134, 167);
}

.v-record .layui-input:focus, .layui-textarea:focus {
  border-color: rgb(116, 134, 167) !important;
}

.v-record div.head {
  max-width: calc(100% - 60px);
}

.v-record .x-admin-sm .layui-btn {
  min-height: 34px;
  border-radius: 3px;
}

.v-record .btns input {
  min-height: 36px;
}

.v-record .danger {
  color: #FF5722;
}

.v-record .layui-layer-photos {
  min-width: 200px;
  min-height: 200px;
}

.v-record .v-s-w {
  display: inline-block;
}

.v-record .v-s-w > input,
.v-record .layui-table-tool-self [title="导出"],
.v-record .layui-table-tool-self [title="打印"] {
  display: none !important;
}

.v-record form.layui-form {
  display: flex;
  align-items: center;
}
</style>
